import { ChargerIndicatorProps } from '../leaflet-map.types';
import { calculateColorSegments } from './calculateColorSegments';
import { calculateSegmentDashes } from './calculateSegmentDashes';
import { generateCircleSegments } from './generateCircleSegments';

const STROKE_WIDTH = 4;
const SVG_SIZE = 14;
const RADIUS = SVG_SIZE / 2 - STROKE_WIDTH / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
const centerPoint = SVG_SIZE / 2;

export const createMediumChargerIndicator = ({
    unavailableConnectors = 0,
    availableConnectors = 0,
    totalConnectors = 0,
    busyConnectors = 0,
}: ChargerIndicatorProps) => {
    const colorSegments = calculateColorSegments({
        unavailableConnectors,
        availableConnectors,
        totalConnectors,
        busyConnectors,
    });

    const segments = calculateSegmentDashes(colorSegments, CIRCUMFERENCE);

    const circleSegments = generateCircleSegments({
        segments,
        centerPoint,
        radius: RADIUS,
        strokeWidth: STROKE_WIDTH,
    });

    const html = `<div style="display: flex; align-items: center; justify-content: center; width: 13px; height: 13px;  background: #F4FAFF; border-radius: 50%;">
        <svg viewBox="0 0 ${SVG_SIZE} ${SVG_SIZE}" width="${SVG_SIZE}" height="${SVG_SIZE}">
                  <circle
                    cx="${centerPoint}"
                    cy="${centerPoint}"
                    r="${RADIUS}"
                    fill="transparent"
                    stroke="#eeeeee"
                    stroke-width="${STROKE_WIDTH}"
                  ></circle>
                  ${circleSegments}
           </svg>
          </div>`;

    return html;
};
